module.exports = __webpack_public_path__ + "img/今日预警背景图.10ca5a95.png";